

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Howl } from "howler";
import { TweenMax, TimelineMax } from "gsap";
@Component
export default class KarutaPlayerEnglish extends Vue {
  @Prop({ type: Array, required: true })
  karutaList!: Array<any>;

  $refs!: {
    se: HTMLAudioElement;
    torifuda01: HTMLElement;
    torifuda02: HTMLElement;
  };

  karutaIndex = 0;
  showNextButton = false;
  loopCount = 0;
  showTorifuda = false;
  showKu = false;
  timerId = -1;
  state = 0; // 0: 読み, 1: 解答

  @Watch("showNextButton")
  onChangeShowNextButton(val: boolean) {
    this.$emit("changeShowNextButton", !val);
  }

  @Watch("showTorifuda")
  onChangeShowTorifuda(val: boolean) {
    this.$nextTick(() => {
      if (val) {
        const tl = new TimelineMax();
        tl.from(this.$refs.torifuda01, {
          x: "50%",
          delay: 2
        });
        tl.from(
          this.$refs.torifuda02,
          {
            x: "-50%"
          },
          "<"
        );
      }
    });
  }

  get torifuda() {
    return this.karutaList[this.karutaIndex].torifuda;
  }

  get ku() {
    return this.karutaList[this.karutaIndex].ku;
  }

  get kuImg() {
    return this.karutaList[this.karutaIndex].imgPath;
  }

  get characters() {
    return this.karutaList[this.karutaIndex].characters;
  }

  get mute() {
    return this.$store.state.mute;
  }

  onKeyPress(e: KeyboardEvent) {
    if (e.key === "Enter") {
      if (this.showNextButton) {
        this.playSE();
        window.setTimeout(() => {
          this.skipKaruta();
        }, 1000);
      }
    } else if (e.key === "r") {
      this.$router.push("/");
    }
  }

  playSE() {
    if (!this.mute) {
      this.$refs.se.pause();
      this.$refs.se.currentTime = 0;
      this.$refs.se.play();
    }
  }

  next() {
    this.playSE();
    window.setTimeout(() => {
      if (this.state == 1) {
        this.skipKaruta();
        this.state = 0;
      } else {
        this.showTorifuda = true;
        this.state = 1;
      }
    }, 1000);
  }

  play(karutaIndex?: number) {
    const self = this;
    let sound;
    karutaIndex =
      typeof karutaIndex === "number" ? karutaIndex : this.karutaIndex;
    this.karutaIndex = karutaIndex;
    const data = this.karutaList[karutaIndex];
    if (data.howl) {
      sound = data.howl;
    } else {
      sound = data.howl = new Howl({
        src: [data.voicePath],
        html5: true,
        preload: true,
        onplay: () => {
          if (this.loopCount === 0) {
            this.showKu = true;
            TweenMax.fromTo(
              ".chara",
              this.characters[0].animation.from,
              this.characters[0].animation.to
            );
          } else if (this.loopCount === 1) {
            TweenMax.to(".ku", {
              scale: 1.1,
              yoyo: true,
              repeat: 1
            });
          }
        },
        onend: () => {
          if (this.loopCount === 0) {
            this.timerId = window.setTimeout(() => {
              this.loopCount++;
              this.play(this.karutaIndex);
            });
          } else {
            this.showNextButton = true;
          }
        }
      });
      sound.mute(this.mute);
    }

    window.setTimeout(sound.play(), 100);
  }

  pause() {
    const sound = this.karutaList[this.karutaIndex].howl;
    sound?.pause();
  }

  skipKaruta() {
    this.showTorifuda = false;
    this.showNextButton = false;
    this.showKu = false;
    this.$nextTick(() => {
      const karutaIndex =
        this.karutaIndex < this.karutaList.length - 1
          ? this.karutaIndex + 1
          : -1;
      this.showNextButton = false;
      if (karutaIndex === -1) {
        this.showKu = false;
        this.$emit("end");
        return;
      }
      if (this.karutaList[karutaIndex].howl) {
        this.karutaList[karutaIndex].howl?.stop();
      }
      this.loopCount = 0;
      this.play(karutaIndex);
    });
  }

  reset() {
    window.clearTimeout(this.timerId);
    if (this.karutaList[this.karutaIndex].howl) {
      this.karutaList[this.karutaIndex].howl?.stop();
    }
    this.karutaIndex = 0;
    this.showKu = false;
  }
}
